import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../../css/qavaApp.css';

export function DailyCashDepositModal (props) {

    let depositTypeRef = useRef('cash');
    let depositDescriptionRef = useRef();
    //let depositTotalAmountRef = useRef();

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal , setShowSupplierModal] = useState(false);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);

    let [disableDepositButton, setDisableDepositButton] = useState(false);




    function submitDailyDeposit(enteredPassword)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002_SDD');
        formData.append('user', acctID);
        formData.append('xDeposityType', depositTypeRef.current.value);
        formData.append('xDepositDescription', depositDescriptionRef.current.value);
        formData.append('xDepositTotalAmount', props.depositAmount);
        //formData.append('xImageFile', selectedFile);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002_SDD',
                user: acctID,
                xDeposityType: depositTypeRef.current.value,
                xDepositDescription: depositDescriptionRef.current.value,
                xDepositTotalAmount: props.depositAmount,
                //xImageFile: selectedFile,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');
        //alert(enteredPassword);

        //setEnteredPassword(event);
        setDisableDepositButton(true);

        submitDailyDeposit(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }


    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonSlides pager='true' options={{direction: 'horizontal'}}>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Payment Type </IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <select name="deposittype" id='deposittype' ref={depositTypeRef }>
                                            <option value='cash'>Cash</option>
                                            <option value='mobile_money'>Mobile Money</option>
                                        </select>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                         </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Deposit Description: </IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter Deposit Description' ref={ depositDescriptionRef }></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Deposit Total Amount: </IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <p>{props.depositAmount}</p>     
                                    </IonCol>
                                </IonRow>
                                {/*<IonRow>
                                    <IonCol size='12'>
                                        <IonButton onClick={() => setShowPasswordModal(true)}> Submit </IonButton>
                                    </IonCol>
                                </IonRow>*/}
                            </IonGrid>

                            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>                        
                       
                        </IonSlide>
                        {/*<IonSlide>
                            <IonLabel>Attachement </IonLabel>
                            <IonItem> 
                            <h1>Upload Supporting Documentation</h1>
                            
                            <form id='fileUpload' onSubmit={() => setShowPasswordModal(true)}>
                                <input type='file' name='xImageFile' accept="image/*" enctype='multipart/form-data' onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                                <IonButton  onClick={() => setTakePhotoStatus(true)}> Take Photo</IonButton>

                                {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}

                                <label for='noAttachment'>No Attachment</label>
                                    <input type='checkbox' id='noAttachment' value='/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg' onClick={(e) => setSelectedFile(e.target.value)}></input>
                            </form>
                            </IonItem>
                            <IonButton onClick={() => setShowPasswordModal(true)}> Submit </IonButton>
                            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>                        
                        </IonSlide>*/}
                    </IonSlides>

                    <IonButton className='modal_footer_button_left' disabled={disableDepositButton} onClick={() => setShowPasswordModal(true)}> Submit </IonButton>
                    <IonButton className='modal_footer_button_right' onClick={() => closeModalHandler(false)}>Cancel </IonButton>

                    </IonModal>) : null
                }
            </React.Fragment>

    )
}